// Synced from heivol KB design-system/site-header-react/ — edit the canon first, then re-sync (see design-system/site-header.md).
export type Theme = 'light' | 'dark';

function isHeivolHost(): boolean {
  return /(^|\.)heivol\.com$/i.test(window.location.hostname);
}

export function getTheme(): Theme {
  const attr = document.documentElement.getAttribute('data-theme');
  return attr === 'dark' ? 'dark' : 'light';
}

export function setTheme(next: Theme): void {
  document.documentElement.setAttribute('data-theme', next);
  try {
    localStorage.setItem('hv-theme', next);
  } catch {
    /* ignore */
  }
  let cookie = `hv-theme=${next}; Path=/; Max-Age=31536000; SameSite=Lax`;
  if (isHeivolHost()) cookie += '; Domain=.heivol.com; Secure';
  document.cookie = cookie;
}

export function toggleTheme(): Theme {
  const next: Theme = getTheme() === 'dark' ? 'light' : 'dark';
  setTheme(next);
  return next;
}
